export enum EBracketTypes {
  BRACKET = "BKT",
  COBRA = "COB",
  SECURITY = "SEC",
  CENTER_SUSPENSION = "CS",
  POST_TOP = "PT",
  MID_POLE = "MID",
  MONGOOSE = "MON",
  OTHER = "OTH",
  UNKNOWN = "UNK",
}

export const LampTypeDisplayMap = {
  HPS: "High Pressure Sodium",
  MV: "Mercury Vapor",
  MH: "Metal Halide",
  LED: "LED",
  LPS: "Low Pressure Sodium",
  INC: "Incandescent",
  FLUO: "Fluorescent",
  UNK: "Unknown",
};

export const BracketTypeDisplayMap = {
  BKT: "Bracket",
  COB: "Cobra",
  SEC: "Security",
  CS: "Center Suspension",
  PT: "Post Top",
  MID: "Mid-Pole Mounting",
  MON: "Mongoose",
  OTH: "Other",
  UNK: "Unknown",
};
